<template>
  <div class="inspection-tour-history">
    <div class="count-list">
      <div class="count-item" v-for="(item, index) in inspectionTourData" :key="index">
        <div class="left-count" v-if="item.key !== 'inspectionClassroom'">
          <div class="count-name">{{ item.name }}</div>
          <div>
            <span class="count-unit">{{ item.num }}</span>
            <span style="color: #9ca5b1; font-size: 14px">&ensp;{{ item.unit }}</span>
          </div>
        </div>
        <div class="left-count" v-else>
          <div class="count-name">
            <span>{{ item.name }}</span>
            <span class="time-change">
              <span class="time-item" :class="showSevenDayData ? 'active-unit' : ''" @click="changeDataShow('seven')">
                近7天
              </span>
              <span>｜</span>
              <span class="time-item" :class="showSevenDayData ? '' : 'active-unit'" @click="changeDataShow('thiry')">
                近30天
              </span>
            </span>
          </div>
          <div>
            <span class="count-unit">{{ showSevenDayData ? item.sevenDayNum : item.thiryDayNum }}</span>
            <span style="color: #9ca5b1; font-size: 14px">&ensp;{{ item.unit }}</span>
          </div>
        </div>
        <div class="right-img">
          <img :src="item.imgsrc" alt="" />
        </div>
      </div>
    </div>
    <div class="history-content">
      <div class="top-filter">
        <div class="filter-left">
          <div class="select-school">
            <span>{{ schoolSelectName }}</span>
            <img
              class="org-container-icon"
              src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202307/ddd303c5e801417d820d391216d4e848.png"
              alt="切换"
              @click="switchingSchoolDialogFlag = true"
            />
          </div>
          <div class="select-box">
            <a-tree-select
              v-model="checkedKeys"
              style="width: 100%"
              :tree-data="campusTreeList"
              tree-checkable
              placeholder="请选择校区/楼栋"
              :show-checked-strategy="SHOW_PARENT"
              dropdownMatchSelectWidth
              :replaceFields="replaceFields"
              :maxTagCount="2"
              @change="handleTreeChange"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            >
              <!-- <a-icon slot="suffixIcon" type="smile" /> -->
              <template slot="title" slot-scope="{ name }">
                <div class="campus-title">
                  {{ name }}
                </div>
              </template>
            </a-tree-select>
          </div>
        </div>
        <div class="filter-right">
          <a-input-search placeholder="请输入教室关键字" v-model="searchKeys" style="width: 200px" @search="onSearch" />
        </div>
      </div>
      <div class="table-content">
        <a-table
          @change="tableChangeEvent"
          :columns="columns"
          :data-source="inspectionTourList"
          :pagination="false"
          :row-key="(record, index) => index"
          :loading="loading"
        >
          <span slot="lastInspectionTime" slot-scope="text, record">
            <span>{{ record.lastInspectionTime || '--' }}</span>
          </span>
          <span slot="action" slot-scope="text, record">
            <span style="cursor: pointer; color: #1572ff" @click="goDetailRouter(record)">详情</span>
          </span>
        </a-table>
        <a-row type="flex" justify="end" style="margin-top: 20px; position: relative">
          <a-pagination
            show-size-changer
            :default-current="1"
            :page-size-options="pageSizeOptions"
            :total="pagination.total"
            :defaultPageSize="50"
            @change="handlePageChange"
            @showSizeChange="onShowSizeChange"
            v-model="pagination.current"
            :pageSize.sync="pagination.pageSize"
            :show-total="(total) => `共 ${total} 条`"
          >
            <template slot="buildOptionText" slot-scope="props">
              <span>{{ props.value }}条/页</span>
            </template>
          </a-pagination>
        </a-row>
      </div>
    </div>
    <SwitchingSchool
      :switchingSchoolDialogFlag="switchingSchoolDialogFlag"
      @handleSwitchingSchoolDialogClose="handleSwitchingSchoolDialogClose"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import SwitchingSchool from '@/components/switchingSchool'
import { TreeSelect } from 'ant-design-vue'
const SHOW_PARENT = TreeSelect.SHOW_PARENT

const columns = [
  {
    title: '校区',
    dataIndex: 'campusName',
    key: 'campusName',
    scopedSlots: { customRender: 'campusName' },
    align: 'left'
  },
  {
    title: '楼栋',
    dataIndex: 'buildingName',
    key: 'buildingName',
    scopedSlots: { customRender: 'buildingName' },
    align: 'left',
    ellipsis: true
  },
  {
    title: '教室',
    dataIndex: 'roomName',
    key: 'roomName',
    scopedSlots: { customRender: 'roomName' },
    align: 'left',
    ellipsis: true
  },
  {
    title: '被巡视次数',
    dataIndex: 'inspectionNumber',
    key: 'inspectionNumber',
    scopedSlots: { customRender: 'inspectionNumber' },
    ellipsis: true,
    align: 'left'
  },
  {
    title: '最近巡视时间',
    dataIndex: 'lastInspectionTime',
    key: 'lastInspectionTime',
    scopedSlots: { customRender: 'lastInspectionTime' },
    ellipsis: true,
    align: 'left'
  },
  {
    title: '操作',
    dataIndex: 'id',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    ellipsis: true,
    class: 'action',
    align: 'center'
  }
]
export default {
  name: 'InspectionTourHistory',
  components: {
    SwitchingSchool
  },
  computed: {
    ...mapGetters('switchingSchool', ['schoolSelect', 'schoolSelectName'])
  },
  watch: {
    schoolSelect: {
      handler: async function (newVal) {
        if (!newVal) return
        this.checkedKeys = []
        this.selectBuildingId = []
        this.selectCampusId = []
        this.pagination.current = 1
        await this.getHistorySummary()
        await this.getCampusList()
        await this.getHistoryList()
      },
      immediate: true
    }
  },
  data() {
    return {
      columns,
      SHOW_PARENT,
      inspectionTourData: [
        {
          key: 'classroomNum',
          name: '教室总数',
          num: 0,
          unit: '个',
          imgsrc: require('../../../assets/img/classroom_img.png')
        },
        {
          key: 'inspectionClassroom',
          name: '已巡视教室',
          sevenDayNum: 0,
          thiryDayNum: 0,
          unit: '个',
          imgsrc: require('../../../assets/img/yxsjs.png')
        },
        {
          key: 'inspectionAllTime',
          name: '累计巡视次数',
          num: 0,
          unit: '次',
          imgsrc: require('../../../assets/img/ljxscs.png')
        },
        {
          key: 'inspectionPeopleNum',
          name: '参与巡视',
          num: 0,
          unit: '人',
          imgsrc: require('../../../assets/img/canyuxunshi.png')
        }
      ],
      inspectionTourList: [],
      searchKeys: '',
      pagination: {
        current: 1,
        pageSize: 50,
        total: 0
      },
      pageSizeOptions: ['50', '100', '150', '200'],
      loading: false,
      switchingSchoolDialogFlag: false,
      showSevenDayData: true,
      showTreeSelectBox: false, // 选择校区楼栋树形选择框
      campusTreeList: [],
      checkedKeys: [],
      replaceFields: {
        children: 'buildingInfos',
        title: 'title',
        key: 'id',
        value: 'id'
      },
      allCampusIds: [], // 当前学校所有的校区ID
      selectCampusId: [], // 选中的校区ID
      selectBuildingId: [] // 选中的楼栋ID
    }
  },
  methods: {
    onSearch() {
      this.pagination.current = 1
      this.getHistoryList()
    },
    goDetailRouter(record) {
      this.$router.push({
        name: 'InspectionTourHistoryDetail',
        params: {
          classroomCode: record.classroomCode,
          detailInfo: record
        }
      })
      localStorage.setItem('classroomInfo', JSON.stringify(record))
    },
    tableChangeEvent(pagination) {
      this.pagination.current = pagination.current
      this.getHistoryList()
    },
    async getHistoryList() {
      const historyList = await this.$http.getInspectionHistoryList({
        keywords: this.searchKeys,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        schoolCode: this.schoolSelect,
        buildingIds: this.selectBuildingId,
        campusIds: this.selectCampusId
      })
      if (historyList.code === 200 && historyList.rt.resultStatus === 1) {
        this.inspectionTourList = historyList.rt.list || []
        this.pagination.total = historyList.rt.totalCount
      }
    },
    // 获取头部汇总数据
    async getHistorySummary() {
      const summary = await this.$http.inspectionHistorySummary({
        schoolCode: this.schoolSelect
      })
      if (summary.code === 200 && summary.rt) {
        this.inspectionTourData.map((item) => {
          switch (item.key) {
            case 'classroomNum':
              item.num = summary.rt.classroomNum
              break
            case 'inspectionAllTime':
              item.num = summary.rt.inspectionAllTime
              break
            case 'inspectionPeopleNum':
              item.num = summary.rt.inspectionPeopleNum
              break
            case 'inspectionClassroom':
              item.sevenDayNum = summary.rt.inspectionClassroomDay7
              item.thiryDayNum = summary.rt.inspectionClassroomDay30
              break
            default:
              break
          }
        })
      }
    },
    async handleSwitchingSchoolDialogClose(isConfirm) {
      this.switchingSchoolDialogFlag = false
    },
    changeDataShow(day) {
      if (day === 'seven') {
        this.showSevenDayData = true
      } else {
        this.showSevenDayData = false
      }
    },
    openTreeSelectBox() {
      this.showTreeSelectBox = !this.showTreeSelectBox
    },
    async getCampusList() {
      const res = await this.$http.getClassroomFilterTree({
        schoolCode: this.schoolSelect
      })
      if (res.code === 200 && res.rt) {
        this.campusTreeList = this.handleData(res.rt.campusList || [], 1)
        this.getAllCampusIds()
      }
    },
    getAllCampusIds() {
      this.allCampusIds = []
      this.campusTreeList.map((item) => {
        this.allCampusIds.push(item.campusId)
      })
      this.checkedKeys = this.allCampusIds
      this.selectCampusId = this.allCampusIds
    },
    handleData(data, level) {
      data.map((children) => {
        children.name = children.campusName || children.buildingName
        children.id = children.campusId || children.buildingId
        children.level = level
        children.sort = children.campusSort || children.buildingSort
        children.scopedSlots = { title: 'title' }
        if (children.buildingInfos && children.buildingInfos.length) {
          this.handleData(children.buildingInfos, 2)
        }
      })
      return data
    },
    handleTreeChange(value, label, e) {
      this.checkedKeys = value
      this.pagination.current = 1
      if (value && value.length) {
        this.selectBuildingId = value.filter((item) => !this.allCampusIds.includes(item))
        this.selectCampusId = value.filter((item) => this.allCampusIds.includes(item))
        this.getHistoryList()
      } else {
        this.inspectionTourList = []
      }
      // console.log('this.checkedKeys', this.selectBuildingId, this.selectCampusId, this.allCampusIds);
    },
    handlePageChange(page, pageSize) {
      this.pagination.current = page
      this.pagination.pageSize = pageSize
      this.getHistoryList()
    },
    onShowSizeChange(current, size) {
      this.pagination.current = current
      this.pagination.pageSize = size
      this.getHistoryList()
    }
  }
}
</script>

<style lang="scss" scoped>
$theme-color: #5f60d3;
.count-list {
  width: 100%;
  height: 110px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 20px;
  align-items: center;
  .count-item {
    height: 110px;
    padding: 24px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left-count {
      flex: 1;
      color: #1e2228;
      text-align: left;
      .count-name {
        font-size: 14px;
        min-width: 170px;
      }
      .count-unit {
        font-size: 36px;
        font-weight: 500;
      }
      .time-change {
        margin-left: 16px;
        font-size: 12px;
        color: #9ca5b1;
      }
      .active-unit {
        color: $theme-color !important;
      }
      .time-item {
        cursor: pointer;
      }
    }
    .right-img {
      width: 60px;
      height: 60px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
.history-content {
  margin-top: 16px;
  min-height: calc(100vh - 110px - 40px - 16px - 56px);
  padding: 16px;
  background: #fff;
  .table-content {
    margin-top: 16px;
  }
}

.top-filter {
  width: 100%;
  height: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .filter-left {
    display: flex;
    align-items: center;
  }
  .select-school {
    margin-right: 10px;
    display: flex;
    align-items: center;
    .org-container-icon {
      margin-left: 4px;
      width: 16px;
      height: 16px;
      display: block;
      cursor: pointer;
      user-select: none;
    }
  }
  .select-box {
    position: relative;
    width: 320px;
    height: 32px;
    text-align: left;
    .select-campus {
      width: 100%;
      height: 32px;
      line-height: 32px;
      padding: 0 8px;
      border-radius: 2px;
      font-size: 12px;
      color: #ddd;
      border: 1px solid #dcdee0;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}

::v-deep {
  .ant-select-selection--multiple .ant-select-selection__rendered {
    height: 32px !important;
    display: flex;
    flex-wrap: nowrap;
  }
  .ant-select-selection--multiple .ant-select-selection__choice {
    min-width: 70px;
  }
  // .ant-select-open .ant-select-selection {
  //   border-color: $theme-color !important;
  //   box-shadow: 0 0 0 2px rgba(21, 114, 255, 0.2) !important;
  // }

  .ant-select-tree-checkbox-checked::after {
    border: 1px solid $theme-color !important;
  }
  .ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner::after {
    background-color: $theme-color;
  }
  // .ant-select-selection {
  //   &:hover {
  //     border-color: $theme-color;
  //   }
  //   &:focus {
  //     box-shadow: 0 0 0 2px rgba(21, 114, 255, 0.2);
  //   }
  // }
  // .ant-select-focused .ant-select-selection {
  //   box-shadow: none !important;
  // }
}
::v-deep .ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner {
  background-color: $theme-color !important;
  border-color: $theme-color !important;
}
::v-deep .ant-select-tree-checkbox .ant-select-tree-checkbox-inner:hover {
  border-color: $theme-color;
}
::v-deep .ant-select-tree li .ant-select-tree-node-content-wrapper {
  max-width: 250px !important;
  .ant-select-tree-title {
    display: flex;
    max-width: 250px;
  }
  .campus-title {
    max-width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
